<mat-card class="card-style-full px-6 py-6 pt-0">
  <!--  <mat-card-header class="flex justify-between items-center">-->
  <!--    <mat-card-title class="">Cadastro Fornecedor</mat-card-title>-->
  <!--    <button class="btn-icon" (click)="close()">-->
  <!--      <mat-icon>close</mat-icon>-->
  <!--    </button>-->
  <!--  </mat-card-header>-->

  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Cadastro Fornecedor</mat-card-title>
    </div>
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      Cancelar
    </button>
    <button
      mat-flat-button
      class="btn-tg w-1/12"
      [disabled]="checkInvalidForm()"
      (click)="createSupplier()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Cadastrar
      }
    </button>
    <!--    <button class="btn-icon" (click)="close()">-->
    <!--      <mat-icon>close</mat-icon>-->
    <!--    </button>-->
  </mat-card-header>

  <div class="mt-4 mb-2"></div>

  <mat-accordion multi>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <h4>Fornecedor</h4>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="mt-4">
        <mat-form-field class="input-tg w-1/5" appearance="outline">
          <mat-label>Tipo Fornecedor</mat-label>
          <mat-select [(value)]="typeClient">
            @for (type of listTypeClient; track type) {
              <mat-option [value]="type.id">{{ type.description }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="mt-4"></div>
        <div [formGroup]="formLegalSupplier" [hidden]="typeClient != 'legal'">
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-5/12" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>

            <mat-form-field class="input-tg w-5/12" appearance="outline">
              <mat-label>Razão social</mat-label>
              <input matInput formControlName="corporate_name" />
            </mat-form-field>

            <mat-form-field class="input-tg w-2/12" appearance="outline">
              <mat-label>CNPJ</mat-label>
              <input
                matInput
                formControlName="cnpj"
                [mask]="'99.999.999/9999-99'"
              />
            </mat-form-field>
          </div>
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Inscrição Estadual</mat-label>
              <input matInput formControlName="reg_state" />
            </mat-form-field>

            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Inscrição Municipal</mat-label>
              <input matInput formControlName="reg_municipal" />
            </mat-form-field>
          </div>
        </div>
        <div
          [formGroup]="formNaturalSupplier"
          [hidden]="typeClient != 'natural'"
        >
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12" appearance="outline">
              <mat-label>CPF</mat-label>
              <input matInput formControlName="cpf" [mask]="'999.999.999-99'" />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12" appearance="outline">
              <mat-label>Prazo de Pagamento (dias)</mat-label>
              <input matInput type="number" formControlName="prazoPagamento" />
            </mat-form-field>
          </div>
          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Estado</mat-label>
              <input
                matInput
                formControlName="state"
                [matAutocomplete]="autoEstadoNatural"
                placeholder="Selecione o estado"
              />
              <mat-autocomplete
                #autoEstadoNatural="matAutocomplete"
                [displayWith]="displayEstado"
              >
                @for (estado of estadosFiltrados$ | async; track estado.UF) {
                  <mat-option [value]="estado">{{ estado.estado }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="input-tg w-6/12" appearance="outline">
              <mat-label>Cidade</mat-label>
              <input
                matInput
                formControlName="city"
                [matAutocomplete]="autoCidadeNatural"
                placeholder="Selecione a cidade"
              />
              <mat-autocomplete #autoCidadeNatural="matAutocomplete">
                @for (cidade of cidadesFiltradas$ | async; track cidade) {
                  <mat-option [value]="cidade">{{ cidade }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="panelVehicleType = true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>Tipos de Veículo</h4>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (panelVehicleType) {
        <div>
          <supplier-vehicle-type (response)="getList($event, 'vehicleType')" />
        </div>
      }
    </mat-expansion-panel>

    @if (typeClient == 'legal') {
      <mat-expansion-panel (opened)="panelAdress = true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Endereço</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panelAdress) {
          <div>
            <address-client-create (response)="getList($event, 'address')" />
          </div>
        }
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelContact = true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Contatos</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panelContact) {
          <div>
            <contact-client-create (response)="getList($event, 'contact')" />
          </div>
        }
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelResponsable = true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Responsáveis</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panelResponsable) {
          <div>
            <responsible-client-create
              (response)="getList($event, 'responsible')"
            />
          </div>
        }
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelFinancial = true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Financeiro</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panelFinancial) {
          <div>
            <h4 class="font-normal">Tipo documento Fiscal</h4>
            <tax-document-client-create
              (response)="getList($event, 'taxDocument')"
            />
            <mat-divider></mat-divider>
            <h4 class="font-normal">Forma Pagamento</h4>
            <payment-methods-client-create
              (response)="getList($event, 'paymentMethod')"
            />
          </div>
        }
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelBankDetails = true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Dados bancários</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panelBankDetails) {
          <div>
            <bank-details-client-create
              (response)="getList($event, 'bankDetails')"
            />
          </div>
        }
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelDocument = true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Documento</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (panelDocument) {
          <div>
            <document-upload-create (response)="getList($event, 'document')" />
          </div>
        }
      </mat-expansion-panel>
    }
    <!--    <mat-expansion-panel>-->
    <!--      <mat-expansion-panel-header>-->
    <!--        <mat-panel-title> <h4>Consultores</h4> </mat-panel-title>-->
    <!--      </mat-expansion-panel-header>-->
    <!--      <div>-->
    <!--        <consultant-client-create (response)="getList($event, 'consultant')" />-->
    <!--      </div>-->
    <!--    </mat-expansion-panel>-->

    <!--    <mat-expansion-panel disabled>-->
    <!--      <mat-expansion-panel-header>-->
    <!--        <mat-panel-title> <h4>Tarifário</h4> </mat-panel-title>-->
    <!--      </mat-expansion-panel-header>-->
    <!--      <div>-->
    <!--        <h2>Tarifário</h2>-->
    <!--      </div>-->
    <!--    </mat-expansion-panel>-->

    <!--    <mat-expansion-panel disabled>-->
    <!--      <mat-expansion-panel-header>-->
    <!--        <mat-panel-title> <h4>SubCliente</h4> </mat-panel-title>-->
    <!--      </mat-expansion-panel-header>-->
    <!--      <div>-->
    <!--        <h2>SubCliente</h2>-->
    <!--      </div>-->
    <!--    </mat-expansion-panel>-->
  </mat-accordion>

  <!--  <div class="flex justify-end mt-3">-->
  <!--    <button mat-flat-button class="btn-tg w-1/5" [disabled]="checkInvalidForm()" (click)="createSupplier()">-->
  <!--      @if (loading) {-->
  <!--      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>-->
  <!--      } @else {-->
  <!--      Cadastrar-->
  <!--      }-->
  <!--    </button>-->
  <!--  </div>-->
</mat-card>
